import { Component, Input, OnInit } from '@angular/core';
import { DiffMatchPatch, Diff } from 'diff-match-patch-ts';

@Component({
	selector: 'app-text-diff',
	templateUrl: './text-diff.component.html',
	styleUrls: ['./text-diff.component.scss'],
})
export class TextDiffComponent implements OnInit {
	@Input() oldText: string = '';
	@Input() newText: string = '';
	diffs: Diff[] = [];

	private dmp = new DiffMatchPatch();

	ngOnInit(): void {
		this.computeDiff();
	}

	computeDiff() {
		this.diffs = this.dmp.diff_main(this.oldText, this.newText);
		this.dmp.diff_cleanupSemantic(this.diffs);
	}
}
